// third-party
import { FormattedMessage } from 'react-intl';

// assets
import ExperimentOutlined from '@ant-design/icons/ExperimentOutlined';
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined';

// icons
const icons = { BiotechOutlinedIcon, ExperimentOutlined };

// ==============================|| MENU ITEMS - PATHOLOGY ||============================== //

const pathology = {
  id: 'labs/lab-management',
  title: <FormattedMessage id="Pathology" />,
  icon: icons.ExperimentOutlined,
  type: 'group',
  visible: (roles, isAdmin) =>
    isAdmin ||
    roles.includes('doctor') ||
    roles.includes('senior_lab_technician') ||
    roles.includes('lab_technician') ||
    roles.includes('lab_collection_staff'),
  children: [
    {
      id: 'lab-management',
      key: 'lab-management',
      title: <FormattedMessage id="Pathology Management" />,
      type: 'item',
      url: '/labs/lab-management',
      icon: icons.BiotechOutlinedIcon,
      visible: (roles, isAdmin) =>
        isAdmin ||
        roles.includes('doctor') ||
        roles.includes('senior_lab_technician') ||
        roles.includes('lab_technician') ||
        roles.includes('lab_collection_staff')
    }
  ]
};

export default pathology;